import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { updateMerchantGeneralBlockAllowedOrganizationIds } from '@src/api'
import { DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

import { UpdateMerchantGeneralBlockAllowedOrganizationIdsError } from './type'

export const useUpdateMerchantGeneralBlockAllowedOrganizationIds = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    unknown,
    AxiosResponse<UpdateMerchantGeneralBlockAllowedOrganizationIdsError>,
    DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
  >({
    mutationFn: (
      params: DefaultApiUpdateMerchantGeneralBlockAllowedOrganizationIdsRequest
    ) =>
      updateMerchantGeneralBlockAllowedOrganizationIds(axiosInstance, params),
  })
}
